import Enumerable from "linq";
import { IFormatObjectEditable } from "..";
import { IFormatAlert } from "../IFormatAlert";
import { IObjectValidator } from "../IObjectValidator";
import { DateObjectEditor } from "../objectEditors";
import { AbstractFormatObjectAlert, ObjectAlert } from "../alerts";

export class DateObjectValidator implements IObjectValidator {
  public validate(object: IFormatObjectEditable): IFormatAlert[] {
    const alerts: AbstractFormatObjectAlert[] = [];
    if (object instanceof DateObjectEditor) {
      if (object.dateCalculateBehavior().isEditable()) {
        const items = object.dateCalculateBehavior().getValue().items;
        if (items.length > 0
          && !Enumerable.from(items).any(s => s.isObject && !s.reference.operator)) {
          alerts.push(new ObjectAlert(object, "計算設定の基準日を選択してください。"));
        }

        if (items.length > 0
          && Enumerable.from(items).where(s => !!s.reference.operator).count() < 1) {
            alerts.push(new ObjectAlert(object, "計算設定の計算対象項目を選択してください。"));
          }
      }
    }
    return alerts;
  }
}
